import { Component, Input } from '@angular/core';
import { DocumentsComponentData } from '@benefitsui/app/pages/documents/documents-page/documents-page.types';

@Component({
  selector: 'app-document-group-page',
  templateUrl: './document-group-page.component.html',
  styleUrls: ['./document-group-page.component.scss']
})
export class DocumentGroupComponent {
  @Input() dataLength!: number;
  @Input() componentData!: DocumentsComponentData;
}
